export default "__VITE_ASSET__ea3ba1b8__"